import styled, { css } from 'styled-components';

export const SelectContainer = styled.button<{ $isFullWidth: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  height: 100%;
  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(2)}`};

  background-color: transparent;
  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  cursor: pointer;

  ${({ $isFullWidth }) =>
    $isFullWidth &&
    css`
      width: 100%;
    `};
`;

export const IconContainer = styled.span<{ $open: boolean }>`
  transform: ${({ $open }) => `rotate(${$open ? 90 : -90}deg)`};
  transition: transform 200ms;

  font-size: 1.2rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
